import {
  Avatar,
  Box,
  Container,
  Grid,
  Paper,
  TableSortLabel,
  Typography,
} from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { visuallyHidden } from "@mui/utils";
import { baseUrl } from "../../services/AzureStorage";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import Helper from "../../common/Helper";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardCard from "../home/DashboardCard";

export default function ComparePlayersSAA(props) {
  let navigate = useNavigate();
  const useStyles = makeStyles((theme) => ({
    root: {
      margin: "5px 15px",
      border: "1px solid lightgrey",
      borderRadius: "10px",
      boxShadow: "2px 2px 11px grey inset",
    },
    listItemIcon: {
      minWidth: "38px",
    },
    imageIcon: {
      width: "100%",
      height: "100%",
      cursor: "pointer",
    },
    iconRoot: {
      textAlign: "center",
      width: "100%",
      height: "50px",
    },
    cardStyle: {
      border: "1px solid lightgrey",
      borderRadius: "10px",
      height: "250px",
    },
    headerText: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerText2: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerTextInfo: {
      color: "rgb(29, 66, 138)",
      fontSize: "14px",
    },
    headerBox: {
      background: "#c1d0ed",
      borderRadius: "17px",
    },
    smBlue: {
      marginLeft: "16px",
      width: 26,
      height: 26,
      color: theme.palette.getContrastText("#0c2c75"),
      backgroundColor: "#1e3f7e",
      position: "relative",
      borderRadius: "50%",
    },
    stickyColumn: {
      position: "sticky",
      background: "white",
      left: 0,
      zIndex: 1,
      paddingRight: theme.spacing(1),
    },
    playerNameStyle: {
      cursor: "pointer",
      "&:hover": {
        color: "blue",
      },
    },
  }));
  const classes = useStyles();
  const {
    favPlayersASAData,
    favPlayersASADataselected,
    playerAnthrosAndStrengthAgiltyColumns,
    Showval,
    notes,
    loading,
    laneShuttleLeft,
    laneShuttleRight,
    threeFour,
    proLane,
    maxVerticalJump,
    standingVerticalJump,
    eventId,
  } = props;

  const [order, setOrder] = React.useState("asc");

  const [orderBy, setOrderBy] = React.useState("playerName");

  const handleSortRequest = (e, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function getComparator(sortOrder, sortOrderBy) {
    return (a, b) => descendingComparator(a, b, sortOrder, sortOrderBy);
  }
  function descendingComparator(a, b, sortOrder, sortOrderBy) {
    if (a[sortOrderBy] === b[sortOrderBy]) {
      return 0;
    } else if (sortOrder === "asc") {
      return a[sortOrderBy] < b[sortOrderBy] ? -1 : 1;
    } else {
      return a[sortOrderBy] < b[sortOrderBy] ? 1 : -1;
    }
  }
  const viewPlayerProfile = (playerId) => {
    navigate(`/${eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${playerId}`, {
      state: { from: "CombineResults", tab: 1 },
    });
  };
  var newplayerAnthrosAndStrengthAgiltyColumns = [];

  playerAnthrosAndStrengthAgiltyColumns &&
    playerAnthrosAndStrengthAgiltyColumns.map((val, index) => {
      if (
        val.id === "playerName" ||
        val.id === "position" ||
        val.id === "collegeOrClub" ||
        val.id === "shuttleRunLeftTrialTime" ||
        val.id === "shuttleRunRightTrialTime" ||
        val.id === "threeFourRunTime" ||
        val.id === "proLaneTrialTime" ||
        val.id === "maxVerticalLeap" ||
        val.id === "standingVerticalLeap"
      ) {
        newplayerAnthrosAndStrengthAgiltyColumns.push({
          id: val.id,
          headerName: val.headerName,
        });
      }
    });
  return (
    <Container maxWidth={false}>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Strength And Agility
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={2} pt={3}>
            <TableContainer>
              {favPlayersASAData && favPlayersASAData.length > 0 && (
                <Table>
                  <TableHead>
                    {newplayerAnthrosAndStrengthAgiltyColumns.map((elem, i) => {
                      return (
                        <TableCell
                          className={
                            elem.id === "playerName"
                              ? classes.stickyColumn
                              : classes.na
                          }
                          sx={{
                            padding: "4px",
                            paddingLeft:
                              elem.id === "playerName" ? "25px" : "0px",
                          }}
                        >
                          <TableSortLabel
                            active={orderBy === elem.id}
                            direction={orderBy === elem.id ? order : "asc"}
                            onClick={(e) => handleSortRequest(e, elem.id)}
                          >
                            {elem.headerName}
                            {orderBy === elem.id ? (
                              <Box component="span" sx={visuallyHidden}>
                                {order === "desc"
                                  ? "sorted descending"
                                  : "sorted ascending"}
                              </Box>
                            ) : null}
                          </TableSortLabel>
                        </TableCell>
                      );
                    })}
                  </TableHead>
                  <TableHead>
                    <TableCell className={classes.stickyColumn}></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>(sec)</TableCell>
                    <TableCell>(sec)</TableCell>
                    <TableCell>(sec)</TableCell>
                    <TableCell>(sec)</TableCell>
                    <TableCell>(ft' in")</TableCell>
                    <TableCell>(ft' in")</TableCell>
                  </TableHead>
                  <TableBody>
                    {Showval
                      ? favPlayersASADataselected
                          .slice()
                          .sort(getComparator(order, orderBy))
                          .map((val, index) => {
                            return (
                              <TableRow>
                                <TableCell
                                  className={classes.stickyColumn}
                                  sx={{ padding: "5px" }}
                                >
                                  <Box display="flex">
                                    {val.headshotURL &&
                                    val.headshotURL !== "" ? (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        src={
                                          val.headshotURL
                                            ? baseUrl(val.headshotURL)
                                            : ""
                                        }
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    ) : (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    )}
                                    &nbsp;&nbsp;
                                    <Typography
                                      variant="body2"
                                      className={classes.playerNameStyle}
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(val.playerID)
                                      }
                                    >
                                      {val.playerName}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.position ? val.position : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.collegeOrClub ? val.collegeOrClub : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.shuttleRunLeftTrialTime
                                    ? val.shuttleRunLeftTrialTime
                                    : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.shuttleRunRightTrialTime
                                    ? val.shuttleRunRightTrialTime
                                    : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.threeFourRunTime
                                    ? val.threeFourRunTime
                                    : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.proLaneTrialTime
                                    ? val.proLaneTrialTime
                                    : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.maxVerticalLeap}"
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {/* {val.standingVerticalFeet}'{" "}
                                    {val.standingVerticalInches}" */}
                                  {val.standingVerticalLeap}"
                                </TableCell>
                              </TableRow>
                            );
                          })
                      : favPlayersASAData
                          .slice()
                          .sort(getComparator(order, orderBy))
                          .map((val, index) => {
                            return (
                              <TableRow>
                                <TableCell
                                  className={classes.stickyColumn}
                                  sx={{ padding: "4px" }}
                                >
                                  <Box display="flex">
                                    {val.headshotURL &&
                                    val.headshotURL !== "" ? (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        src={
                                          val.headshotURL
                                            ? baseUrl(val.headshotURL)
                                            : ""
                                        }
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    ) : (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    )}
                                    &nbsp;&nbsp;
                                    <Typography
                                      variant="body2"
                                      className={classes.playerNameStyle}
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(val.playerID)
                                      }
                                    >
                                      {val.playerName}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.position ? val.position : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.collegeOrClub ? val.collegeOrClub : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.shuttleRunLeftTrialTime
                                    ? val.shuttleRunLeftTrialTime
                                    : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.shuttleRunRightTrialTime
                                    ? val.shuttleRunRightTrialTime
                                    : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.threeFourRunTime
                                    ? val.threeFourRunTime
                                    : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.proLaneTrialTime
                                    ? val.proLaneTrialTime
                                    : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {/* {val.maxVerticalFeet}' {val.maxVerticalInches}
                                    " */}
                                  {val.maxVerticalLeap}"
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {/* {val.standingVerticalFeet}'{" "}
                                    {val.standingVerticalInches}" */}
                                  {val.standingVerticalLeap}"
                                </TableCell>
                              </TableRow>
                            );
                          })}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </Grid>
        </Paper>
      </Box>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Strength And Agility
              </Typography>
            </Box>
            <Box display="flex" pl={2}>
              {notes &&
                notes.length > 0 &&
                notes.find(
                  (x) =>
                    x.childName.replace(/\s/g, "").toLowerCase() ===
                    "StrengthAndAgility".toLowerCase()
                ).isActive && (
                  <>
                    {/* <InfoOutlinedIcon style={{ color: "#fff" }} /> */}
                    <Typography
                      // className="subtitle2"
                      className={classes.headerTextInfo}
                    >
                      {
                        notes.find(
                          (x) =>
                            x.childName.replace(/\s/g, "").toLowerCase() ===
                            "StrengthAndAgility".toLowerCase()
                        ).description
                      }
                    </Typography>
                  </>
                )}
            </Box>
          </Box>

          {loading && (
            <Box sx={{ display: "flex" }}>
              <CircularProgress />
            </Box>
          )}
          {/* <Loader isLoading={loading} /> */}
          <Grid container spacing={2} pt={2}>
            <DashboardCard
              title="Lane Shuttle Left(s)"
              data={laneShuttleLeft}
              value="2010"
              unit="(sec)"
              from="CombineResults"
              tab={1}
              eventId={eventId}
            />

            <DashboardCard
              title="Lane Shuttle Right(s)"
              data={laneShuttleRight}
              value="2011"
              unit="(sec)"
              from="CombineResults"
              tab={1}
              eventId={eventId}
            />

            <DashboardCard
              title="3/4 Court Sprint (s)"
              data={threeFour}
              value="202"
              unit="(sec)"
              from="CombineResults"
              tab={1}
              eventId={eventId}
            />

            <DashboardCard
              title="Pro Lane(s)"
              unit="(sec)"
              data={proLane}
              value="203"
              from="CombineResults"
              tab={1}
              eventId={eventId}
            />

            <DashboardCard
              title="Max Vertical Jump"
              data={maxVerticalJump}
              unit={`(in")`}
              value="204"
              from="CombineResults"
              tab={1}
              eventId={eventId}
            />

            <DashboardCard
              title="Standing Vertical"
              data={standingVerticalJump}
              unit={`(in")`}
              value="205"
              from="CombineResults"
              tab={1}
              eventId={eventId}
            />
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
}
